// A 1-2 character term such as "0" is treated by the backend as an empty search (full-history query).
export const MIN_SEARCH_TERM_LENGTH = 3;

export function isSearchableTerm(term: string | null | undefined): boolean {
  return typeof term === 'string' && term.trim().length >= MIN_SEARCH_TERM_LENGTH;
}
